import { render } from "./horizontal-topbar.vue?vue&type=template&id=40b4df3c"
import script from "./horizontal-topbar.vue?vue&type=script&lang=js"
export * from "./horizontal-topbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__